import React from 'react';

const About: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">
            About <span className="hero-highlight">VoyCalc</span>
          </h1>
          <p className="about-hero-subtitle">
            Built by shipping professionals, for shipping professionals.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-grid">
            {/* Our Story */}
            <div className="about-card about-card-wide">
              <div className="about-card-icon">
                <i className="bi bi-compass"></i>
              </div>
              <h3>Our Mission</h3>
              <p>
                VoyCalc was born from a simple observation: commercial shipping decisions
                deserve better tools. We set out to create a voyage calculator that's
                powerful enough for complex estimates, yet simple enough to use on the go.
              </p>
              <p>
                Built with guidance from industry veterans, VoyCalc combines decades of
                maritime expertise with modern technology to give you the edge in
                today's competitive market.
              </p>
            </div>

            {/* Independence */}
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-shield-check"></i>
              </div>
              <h3>Independent</h3>
              <p>
                We're not owned by any shipping company, venture capital, or private
                equity firm. This independence means our only focus is building the
                best tool for you.
              </p>
            </div>

            {/* Focus */}
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-bullseye"></i>
              </div>
              <h3>Focused</h3>
              <p>
                We're not a VMS. We do one thing exceptionally well: voyage estimation.
                All the power of enterprise tools, none of the complexity.
              </p>
            </div>

            {/* Lightweight */}
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-phone"></i>
              </div>
              <h3>Mobile-First</h3>
              <p>
                Make decisions anywhere. VoyCalc is designed to work seamlessly
                across all your devices, from desktop to smartphone.
              </p>
            </div>

            {/* Fast */}
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-lightning-charge"></i>
              </div>
              <h3>Lightning Fast</h3>
              <p>
                Re-use your data efficiently. Create accurate voyage estimates in
                minutes, not hours. Speed matters when opportunities arise.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="about-cta">
            <p className="about-cta-text">
              Ready to streamline your voyage calculations?
            </p>
            <a href="/?page=price" className="btn-about-cta">
              Get Started
              <i className="bi bi-arrow-right ms-2"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
